import {
  Identifiable,
  Project,
  ProjectReport,
  Zone,
  zoneProjectsRetrievalFilter,
} from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { mapWithConcurrency } from "../../../utils/concurrency";
import { Interactor } from "./types";

const PROJECT_REPORTS_CONCURRENCY = 10;

function flattenReports(
  reportsChunk: {
    project: Identifiable<Project>;
    zone: Identifiable<Zone>;
    report: Identifiable<ProjectReport>;
  }[][],
): {
  project: Identifiable<Project>;
  zone: Identifiable<Zone>;
  report: Identifiable<ProjectReport>;
}[] {
  return reportsChunk.reduce((reports, chunk) => [...reports, ...chunk], []);
}

function createInteractor(repository: Repository): Interactor {
  return (zone) =>
    present(
      repository
        .getZoneProjects(zone, {
          ...zoneProjectsRetrievalFilter,
          limit: 99999999,
        })
        .then((projects) =>
          mapWithConcurrency(projects, PROJECT_REPORTS_CONCURRENCY, (project) =>
            repository
              .getProjectReports(project)
              .then((reports) =>
                reports.map((report) => ({ zone, project, report })),
              ),
          ),
        )
        .then(flattenReports)
        .then((reports) => ({ reports, zone }))
        .catch((error) => Promise.reject(zone)),
    );
}

export type { Interactor };

export { createInteractor };
